import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { NodeSection } from "./constants";
import { NodeProjection } from "./NodeProjection";
/**
 * Convert prop from flexible array format to raw value
 */
export var Node = /*#__PURE__*/function (_NodeProjection) {
  _inherits(Node, _NodeProjection);
  var _super = _createSuper(Node);
  function Node(active, children, props, styles, params) {
    var _this;
    _classCallCheck(this, Node);
    _this = _super.call(this, active, children, props, styles, params);
    _this.active = active;
    _this.children = children;
    _this.props = props;
    _this.styles = styles;
    _this.params = params;
    return _this;
  }
  _createClass(Node, [{
    key: "accept",
    value: function accept(visitor) {
      visitor.visit(this.children, {
        section: NodeSection.CHILDREN
      });
      visitor.visit(this.active, {
        section: NodeSection.ACTIVE
      });
      visitor.visit(this.props, {
        section: NodeSection.PROPS
      });
      visitor.visit(this.styles, {
        section: NodeSection.STYLES
      });
    }
  }]);
  return Node;
}(NodeProjection);